import { render, staticRenderFns } from "./setmealSnake.vue?vue&type=template&id=09aea0af&scoped=true"
import script from "./setmealSnake.vue?vue&type=script&lang=js"
export * from "./setmealSnake.vue?vue&type=script&lang=js"
import style0 from "./setmealSnake.vue?vue&type=style&index=0&id=09aea0af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aea0af",
  null
  
)

export default component.exports